<template>
    <div class="toolbar">
        <div style="float: left;">
            <PsButton :disabled="executionState.readValue || (!executionState.paused && executionState.running)" :model="playContinue.label" :icon="playContinue.icon" :icon-color="playContinue.iconColor" @click="execute('normal')"></PsButton>
            <PsButton :disabled="executionState.readValue || (!executionState.paused && executionState.running)" :model="nextLine.label" :icon="nextLine.icon" :icon-color="nextLine.iconColor" @click="execute('toNextLine')"></PsButton>
            <PsButton :disabled="!executionState.running" :model="'Parar'" :icon="'fa-stop'" :icon-color="'fa-red'" @click="stop"></PsButton>
        </div>
        <div style="float: right;">
            <PsButton :disabled="executionState.running" :model="'Predefinir Entrada'+(hasPredefinedEntries ? '*' : '')" :icon="'fa-bookmark'" :icon-color="'fa-orange'" @click="predefinedEntries"></PsButton>
            <PsButton :model="'Pantalla'" :raised="screenVisible" :icon="'fa-desktop'" :icon-color="'fa-blue'" @click="toggleScreen"></PsButton>
            <PsButton :model="'Inspector'" :raised="inspectorVisible" :icon="'fa-eye'" :icon-color="'fa-purple'" @click="toggleInspector"></PsButton>
        </div>
        <a href="#" class="helper-link" style="display:none;">¿Problemas?</a>
    </div>
</template>

<script>
    import { EventBus } from './../../EventBus.js'

    import PsButton from './../Widget/PsButton'

    export default {
        name: 'Toolbar',
        props: ['executionState', 'hasPredefinedEntries', 'id', 'inspectorVisible', 'screenVisible'],
        components: {
            PsButton
        },
        created () {
            this.playContinue = this.buttons.play
            this.nextLine = this.buttons.playNextLine
        },
        watch: {
            'executionState.running' (running) {
                if (!running) {
                    this.playContinue = this.buttons.play
                    this.nextLine = this.buttons.playNextLine
                } else {
                    this.playContinue = this.buttons.stepContinue
                    this.nextLine = this.buttons.continueNextLine
                }
            }
        },
        mounted () {
        },
        methods: {
            execute (nextAction) {
                EventBus.$emit('editor.execute.' + this.id, nextAction)
            },
            stop () {
                EventBus.$emit('editor.stopExecution.' + this.id)
            },
            predefinedEntries () {
                EventBus.$emit('predefined.show.' + this.id)
            },
            toggleScreen () {
                EventBus.$emit('screen.toggle.' + this.id)
            },
            toggleInspector () {
                EventBus.$emit('inspector.toggle.' + this.id)
            }
        },
        data () {
            return {
                buttons: {
                    play: {
                        icon: 'fa-play',
                        iconColor: 'fa-green',
                        label: 'Ejecutar'
                    },
                    pause: {
                        icon: 'fa-pause',
                        iconColor: 'fa-yellow',
                        label: 'Pausa'
                    },
                    stepContinue: {
                        icon: 'fa-chevron-circle-right',
                        iconColor: 'fa-green',
                        label: 'Continuar'
                    },
                    continueNextLine: {
                        icon: 'fa-step-forward',
                        iconColor: 'fa-light-blue',
                        label: 'Siguiente Paso'
                    },
                    playNextLine: {
                        icon: 'fa-step-forward',
                        iconColor: 'fa-light-blue',
                        label: 'Paso a Paso'
                    }
                },
                playContinue: {
                    icon: '',
                    iconColor: '',
                    label: ''
                },
                nextLine: {
                    icon: '',
                    iconColor: '',
                    label: ''
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    /*
     * Widgets
     */

    .toolbar {
        height: 36px;
        padding-bottom: 2px;
        padding-top: 2px;
    }

    .toolbar a.helper-link {
        float: right;
        color: #2C2CCE;
        font-size: 12px;
        line-height: 32px;
        text-decoration: none;
    }
    .toolbar a.helper-link:hover {
        color: #4C4CEE;
        text-decoration: underline;
    }


</style>


// WEBPACK FOOTER //
// src/Components/CodeEditor/Toolbar.vue